import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class UpdateTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Update Settings" },
        { name: "descriptionColumn", title: "Description" }
      ],
      rows: [
        { actionColumn: 'Camera Model', descriptionColumn: 'Displays your camera model number - For more information on your camera model check our Complete List' },
        { actionColumn: 'Firmware Version', descriptionColumn: 'Version of the operating system of your camera. Information about a software update can be found HERE.' },
        { actionColumn: 'WebUI Version', descriptionColumn: 'Version of the web user interface of your camera. Information about a software update can be found HERE.' },
        { actionColumn: 'Software is up to date', descriptionColumn: 'You will be shown link to the update once a newer version of the camera software becomes available. Please be aware that you have to unzip the update.pkg file from the ZIP container first, before uploading it to your camera!' },
        { actionColumn: 'Browse', descriptionColumn: 'Click here to browse for the update.pkg file and submit. More information for the software update can be found HERE.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

UpdateTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(UpdateTable)